<script setup lang="ts">
withDefaults(
  defineProps<{
    cardWidth: number
  }>(),
  {
    cardWidth: 190,
  },
)
</script>

<template>
  <div
    class="rounded-lg max-w-full bg-light-ui-200 dark:bg-dark-ui-200"
    :style="{ width: `${cardWidth}px`, height: `${cardWidth / 2}px` }"
  ></div>
</template>
